import { data } from "react-router-dom";

type Field = {
  name: string | number;
  id?: string | number;
  title: string;
  type: "text" | "radio" | "select";
  dataType?: "number";
  options?: string[];
  nestedFields?: Field[];
  validation?: {
    min?: number;
    max?: number;
    message?: string;
  };
};

type Section = {
  title: string;
  fields: Field[];
};

// if Other than OFC
export const sectionsNoOFC: any[] = [
  {
    title: "ROW & Utility Corridor Details",
    fields: [
      {
        title:
          "Whether sufficient vacant ROW/utility corridor is available for accommodation of the proposed utility?", // new need to add a pop for this question
        name: "width_of_vacant_row", // need to add on type and redux
        id: 400,
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        title:
          "Whether utility ducts are available at the site for accommodation of the proposed utility?", // 383
        name: "selectedDuctsAvailable",
        id: 383,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Details of dimensions of the existing utility duct (in meters):", // new
            name: "existing_duct_dimension_details",
            type: "text",
            dataType: "number",
          },
          {
            title: "Details of existing utilities within the ducts:",
            name: "duct_utility_details",
            type: "text",
            dataType: "string",
          },
        ],
      },
      {
        title:
          "Are there any existing damages or anticipated difficulties in laying/accommodating the utility in the NH ROW?", // 395
        id: 395,
        name: "existingUtilityDetails",
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Please provide the details.", // need to check
            name: "ofc_damage_details",
            type: "text",
            dataType: "string",
          },
        ],
      },
      {
        title: "Right of Use (in meters):",
        name: "right_of_use",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Total area of NH ROW utilized for accommodation of the proposed utilities (in square metres):",
        name: "utilized_nh_land_area",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Dimensions of the proposed utilities, including dimensions of duct pipe/casing as applicable (in metres):",
        name: "proposed_utility_dimension",
        type: "text",
        dataType: "number",
      },
    ],
  },
  {
    title: "ROW Measurements & Utility Proposal",
    fields: [
      {
        title:
          "Width of available ROW (in metres) – Left side from the centerline towards increasing chainage/KM direction:",
        name: "available_row_width_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Width of available ROW (in metres) – Right side from the centerline towards increasing chainage/KM direction:",
        name: "available_row_width_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to Lay Utility - Left side from the centerline towards increasing Chainage or KM Direction (in metres):",
        name: "proposed_utility_distance_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to Lay Utility - Right side from the centerline towards increasing Chainage or KM Direction (in metres):",
        name: "proposed_utility_distance_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to acquire the land at the applicant’s own cost – Left side from the centerline (in metres):",
        name: "land_acquisition_proposal_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to acquire the land at the applicant’s own cost – Right side from the centerline (in metres):",
        name: "land_acquisition_proposal_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Total quantum of land to be acquired by the applicant (in metres):",
        name: "total_land_to_be_acquired",
        type: "text",
        dataType: "number",
      },
    ],
  },
  {
    title: "Existing Infrastructure & Proposed Development",
    fields: [
      {
        title:
          "Details of already laid services if any along the proposed Route:",
        name: "already_laid_services_desc",
        type: "text",
        dataType: "alphanumeric",
      },
      {
        title: "Number of Existing Lanes?",
        name: "number_of_existing_lanes",
        type: "text",
        dataType: "number",
        validation: { min: 1, max: 8 },
      },
      {
        title: "Does a service road exist?", // 242
        name: "serviceRoadExists",
        id: 242,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Left side from the centerline (in metres):",
            name: "left_side_center_line",
            type: "text",
            dataType: "number",
          },
          {
            title: "Right side from the centerline (in metres):",
            name: "right_side_center_line",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        title:
          "Proposed Service Road - Left side from the centerline (in metres):",
        name: "proposed_service_road_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposed Service Road - Right side from the centerline (in metres):",
        name: "proposed_service_road_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Whether the proposed cable is to be laid after the service road or between the service road and the main carriageway:",
        name: "cable_position_within_right_of_way",
        type: "text",
        dataType: "string",
      },
      {
        title:
          "Whether details of arrangements for crossing or laying utilities across existing culverts and bridges:",
        name: "utility_crossing_arrangement_id",
        type: "select",
        options: [],
      },
      {
        title:
          "Is crossing of the road involved in the proposed utility installation?", // 244
        name: "crossingInvolved",
        id: 244,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Select Conduit / Encasement Type:",
            name: "cable_encasement_type",
            type: "select",
            options: ["Encased in Pipes", "Through Conduits", "Not Compliant"],
          },
          {
            title:
              "Are existing drainage structures proposed to carry utility pipelines?", //245
            name: "existingDrainageStructuresForUtility",
            id: 245,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "The utility services shall cross the National Highway preferably on a line normal to it or as nearly so as practicable Utility company shall be permitted to cross the National Highway either through structure or conduits specially built for that purpose. The casing/conduit pipe should, as minimum extend from drain to drain in cuts and toe to toe of slope in the fills and shall be designed in accordance with the provision of IRC and executed following the specifications of the ministry?", //246
            name: "pipelinePerpendicularToHighway",
            id: 246,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "The casing pipe may be installed under the route embankment either by boring or by digging a trench. Installation by the boring method is preferred.?", //362
            name: "installationByBoring",
            id: 362,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "Is the casing/conduit pipe made of steel, cast iron, or reinforced concrete, with adequate strength and internal space for easy withdrawal of the carrier pipe/cable?", //247
            name: "conduitPipeMaterialAdequate",
            id: 247,
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                title:
                  "Mention the type of casing/conduit pipe used for the utility line:",
                name: "utility_line_casing_type",
                type: "text",
                dataType: "string",
              },
            ],
          },
          {
            title:
              "Are the ends of the casing/conduit pipe sealed from the outside to prevent it from acting as a drainage path?", //248
            name: "sealedPipeDrainage",
            id: 248,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "Does the casing/conduit pipe extend at least from the drain in cut sections to the toe of the slope in fill sections?", //249
            name: "coduitPipeFillSection",
            id: 249,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "The top of the casing/conduit pipe should be at least 1.65 metres below the surface of the road and at least 0.3 metres below the drain invert?", // 364
            name: "conduitPipeTop",
            id: 364,
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                title:
                  "Please specify the depth of the casing/conduit pipe below the surface of the road (in metres):",
                name: "casing_depth_meters",
                type: "text",
                dataType: "number",
                validation: { min: 1.65 },
              },
            ],
          },
          {
            title:
              "Is trenchless technology (HDD method) proposed for road crossing, especially where the pavement is cement concrete or dense bituminous concrete?", //251
            name: "trenchlessHddProposed",
            id: 251,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "The casing/conduit pipe shall be installed with an even bearing throughout its length and in such a manner as to prevent the formation of a waterway along it?",
            name: "waterway_prevention_compliance",
            type: "radio",
            options: ["Yes", "No"],
          },
        ],
      },
      {
        title: "Methodology of laying of utilities? ",
        name: "laying_methodology",
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title:
              "Open trenching method (allowed only in utility corridors where pavement is neither cement concrete nor dense bituminous concrete). Is the proposed methodology for laying the utility pipeline/OFC the Open Trenching method?", //261
            name: "openTrenchingProposed",
            id: 261,
            type: "radio",
            options: ["Yes", "No"],
            nestedFields: [
              {
                title: "Describe the trench refilling methodology: ",
                name: "trench_refilling_methodology",
                type: "text",
                dataType: "string",
              },
              {
                title:
                  "Is the proposed trench width at least 30 cm but not more than 60 cm wider than the outer diameter of the pipe?", //262
                name: "trenchWidthCompliant",
                id: 262,
                type: "radio",
                options: ["Yes", "No"],
                nestedFields: [
                  {
                    title:
                      "Please specify the width of trench for open trenching method (in centimeters): ",
                    name: "trench_width_over_pipe_cm",
                    type: "text",
                    dataType: "number",
                    validation: { min: 30, max: 60 },
                  },
                ],
              },
              {
                title:
                  "Is the trench bedding proposed to be at least 30 cm deep, made of granular material that is free from lumps, clods, and cobbles, properly graded to ensure a firm surface without abrupt changes in bearing capacity, with unsuitable soil and rock edges excavated and replaced with selected material?", //263
                name: "trenchBeddingProper",
                id: 263,
                type: "radio",
                options: ["Yes", "No"],
                nestedFields: [
                  {
                    title:
                      "Please specify the depth of trench bedding (in centimeters):",
                    name: "trench_bedding_depth_cm",
                    type: "text",
                    dataType: "number",
                    validation: { min: 30 },
                  },
                ],
              },
              {
                title:
                  "Is the backfill planned to be completed in two stages: (i) side fill up to the top of the pipe, and (ii) overfill up to the bottom of the road crust?", //264
                name: "backfillTwoStage",
                id: 264,
                type: "radio",
                options: ["Yes", "No"],
              },
              {
                title:
                  "Is the side fill proposed to consist of granular material laid in 15 cm thick layers, compacted using mechanical tamping and moisture control to 95% Proctor density, with overfill compacted to match the density of removed material?", //265
                name: "sideFillGranular",
                id: 265,
                type: "radio",
                options: ["Yes", "No"],
                nestedFields: [
                  {
                    title:
                      "Please specify the side fill thickness of layer consist of granular material to fill (in centimeters):",
                    name: "side_fill_layer_thickness_cm",
                    type: "text",
                    dataType: "number",
                  },
                ],
              },
              {
                title:
                  "The road crust shall be built to the same strength as the existing crust on either side of the trench. Is the road crust planned to be rebuilt to the same strength, ensuring no dip formation?", //266
                name: "roadCrustRebuilt",
                id: 266,
                type: "radio",
                options: ["Yes", "No"],
              },
              {
                title:
                  "Will the excavation be protected with flagmen, warning signs, barricades, and red lights during night hours?", //267
                name: "excavationProtected",
                id: 267,
                type: "radio",
                options: ["Yes", "No"],
              },
              {
                title:
                  "If required, will a road diversion be constructed at the expense of the utility-owning agency?", //268
                name: "roadDiversionByUtility",
                id: 268,
                type: "radio",
                options: ["Yes", "No"],
              },
            ],
          },
          {
            title: "Open cut method?", // 374
            name: "openCutMethodProposed",
            id: 374,
            type: "radio",
            options: ["Yes", "No"],
          },
          {
            title:
              "Laying of cable/duct pipeline through cross-drainage (CD) works and method of laying?", //270
            name: "cdWorksSpecified",
            id: 270,
            type: "radio",
            options: ["Yes", "No"],
          },
        ],
      },
    ],
  },
  // {
  //   title: "Safety Measures, Diversions & Legal Documentation",
  //   fields: [
  //     {
  //       title:
  //         "Performance bank guarantee in favour of NH has to be obtained @ Rs. 100 per running metre for the initial period (extendable if required until satisfactory completion of work) as security for proper filling, compaction, and debris removal for the excavated trench. No payment shall be made by NH to the licensee for clearing debris/loose earth.", //378
  //       name: "undertakingOnStampPaper",
  //       id: 378,
  //       type: "radio",
  //       options: ["Yes", "No"],
  //       nestedFields: [
  //         {
  //           title: "Performance BG as per above is to be obtained?", //379
  //           name: "performanceBankGuaranteeSubmitted",
  //           id: 379,
  //           type: "radio",
  //           options: ["Yes", "No"],
  //         },
  //         {
  //           title: "Confirmation of BG has been obtained as per NH guidelines.", //380
  //           name: "bankGuaranteeObtained",
  //           id: 382,
  //           type: "radio",
  //           options: ["Yes", "No"],
  //         },
  //       ],
  //     },
  //   ],
  // },
];

// IF OFC
export const sectionsIfOFC: any[] = [
  {
    title: "ROW & Utility Corridor Details",
    fields: [
      {
        title:
          "Whether sufficient vacant ROW/utility corridor is available for accommodation of the proposed utility?", // new need to add a pop for this question
        name: "width_of_vacant_row",
        id: 400,
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        title:
          "Whether utility ducts are available at the site for accommodation of the proposed utility?", // 383
        name: "selectedDuctsAvailable",
        id: 383,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Details of dimensions of the existing utility duct:(in meters)", // new
            name: "existing_duct_dimension_details",
            type: "text",
            dataType: "number",
          },
          {
            title: "Details of existing utilities within the ducts:",
            name: "duct_utility_details",
            type: "text",
            dataType: "string",
          },
        ],
      },
      {
        title:
          "Are there any existing damages or anticipated difficulties in laying/accommodating the utility in the NH ROW? ", // 395
        id: 395,
        name: "existingUtilityDetails",
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Please provide the details:", // need to check
            name: "ofc_damage_details",
            type: "text",
            dataType: "string",
          },
        ],
      },
      {
        title: "Right of Use (in meters):",
        name: "right_of_use",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Total area of NH ROW utilized for accommodation of the proposed utilities (in square metres):",
        name: "utilized_nh_land_area",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Dimensions of the proposed utilities, including dimensions of duct pipe/casing as applicable (in metres):",
        name: "proposed_utility_dimension",
        type: "text",
        dataType: "number",
      },
    ],
  },
  {
    title: "ROW Measurements & Utility Proposal",
    fields: [
      {
        title:
          "Width of available ROW (in metres) – Left side from the centerline towards increasing chainage/KM direction:",
        name: "available_row_width_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Width of available ROW (in metres) – Right side from the centerline towards increasing chainage/KM direction:",
        name: "available_row_width_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to Lay Utility - Left side from the centerline towards increasing Chainage or KM Direction (in metres):",
        name: "proposed_utility_distance_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to Lay Utility - Right side from the centerline towards increasing Chainage or KM Direction (in metres):",
        name: "proposed_utility_distance_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to acquire the land at the applicant’s own cost – Left side from the centerline (in metres):",
        name: "land_acquisition_proposal_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposal to acquire the land at the applicant’s own cost – Right side from the centerline (in metres):",
        name: "land_acquisition_proposal_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Total quantum of land to be acquired by the applicant (in metres):", // new
        name: "total_land_to_be_acquired",
        type: "text",
        dataType: "number",
      },
    ],
  },
  {
    title: "Existing Infrastructure & Proposed Development",
    fields: [
      {
        title:
          "Details of already laid services, if any, along the proposed route:",
        name: "already_laid_services_desc",
        type: "text",
        dataType: "alphanumeric",
      },
      {
        title: "Number of Existing Lanes:",
        name: "number_of_existing_lanes",
        type: "text",
        dataType: "number",
        validation: { min: 1, max: 8 },
      },
      {
        title: "Does a service road exist?", // 242
        name: "serviceRoadExists",
        id: 242,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Left side from the centerline (in metres):", // pending
            name: "left_side_center_line",
            type: "text",
            dataType: "number",
          },
          {
            title: "Right side from the centerline (in metres):", // pending
            name: "right_side_center_line",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        title:
          "Proposed Service Road - Left side from the centerline (in metres):",
        name: "proposed_service_road_left",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Proposed Service Road - Right side from the centerline (in metres):",
        name: "proposed_service_road_right",
        type: "text",
        dataType: "number",
      },
      {
        title:
          "Whether the proposed cable is to be laid after the service road or between the service road and the main carriageway:",
        name: "cable_position_within_right_of_way",
        type: "text",
        dataType: "string",
      },
      {
        title:
          "Whether details of arrangements for crossing or laying utilities across existing culverts and bridges:",
        name: "utility_crossing_arrangement_id",
        type: "select",
        options: [],
      },
      {
        title:
          "Details of calculation for performance bank guarantee in accordance with Ministry’s guideline NH/36094/01/2022-S&R(P&B) dated 17 April, 2023. (Mandatory, 20 MB)", // 254
        name: "calculationForPerformanceBankGuarantee",
        id: 401,
        type: "radio",
        options: ["Yes", "No"],
      },
    ],
  },
  {
    title: "Utility Corridor Guidelines Based on ROW Width",
    fields: [
      {
        title:
          "Where the duct cable is laid at the edge within a 2-metres-wide utility corridor, considering future widening?", // 252
        name: "ductCableLayout",
        id: 252,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title:
              "Please specify the distance of duct cable laid at the edge within the corridor:",
            name: "distance_from_duct_edge_within_corridor",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        title:
          "Where land has already been acquired for future widening/augmentation to 4/6/8-laning and the new carriageway alignment is fixed, is the cable/utility for 8-laning laid within a 2-metre corridor on the side where no additional land acquisition is planned?", // 253
        name: "landAcquiredFor8Laning",
        id: 253,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title:
              "Please specify the distance of cable laid within the corridor (in metres):",
            name: "distance_from_edge_within_corridor",
            type: "text",
            dataType: "number",
          },
        ],
      },
      {
        title:
          "In cases where the available ROW is only sufficient for the carriageway, central verge, shoulders, and drains (e.g., hilly/rolling terrain), is the cable laid outside or clear of the drainage structures?", // 255
        name: "rowOnlyForCarriageDrainCableClear",
        id: 255,
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        title:
          "Where land strip for utility corridor can’t be conveniently earmarked (available ROW restricted to the toe of the embankment) for laying of cable/ducts, the permission may be refused?", //256
        name: "restrictedRowPermissionRefused",
        id: 256,
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        title:
          "Is crossing of the road involved in the proposed utility installation?", // 244
        name: "crossingInvolved",
        id: 244,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Is trenchless technology used for utility laying?",
            id: 398,
            name: "utilityLayingTechnology",
            type: "radio",
            options: ["Yes", "No"],
          },
        ],
      },
      {
        title: "Methodology for laying the utilities: ",
        name: "laying_methodology",
        type: "text",
        dataType: "string",
      },
      {
        title:
          "Is the proposed methodology for laying the utility pipeline/OFC the Open Trenching method (allowed only in utility corridors where pavement is neither cement concrete nor dense bituminous concrete)?", // 386
        name: "openTrenchingProposed",
        id: 386,
        type: "radio",
        options: ["Yes", "No"],
        nestedFields: [
          {
            title: "Describe the trench refilling methodology: ", // missing
            name: "trench_refilling_methodology",
            type: "text",
            dataType: "string",
          },
        ],
      },
      {
        title:
          "Is Horizontal Directional Drilling (HDD) method proposed for laying the utility pipeline or OFC?", // 387
        name: "hddMethodForPipeline",
        id: 387,
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        title:
          "Has the method for laying OFC through cross-drainage (CD) works been specified, including whether the cable is proposed to be hung outside the parapet? ", // 390
        name: "ofcCableOnMedian",
        id: 390,
        type: "radio",
        options: ["Yes", "No"],
      },
    ],
  },
];
